// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.font-option {
  cursor: pointer;
}

.style-chooser .style-chooser-inner .dropdown-toggle {
  display: flex;
  flex-flow: row;
  align-items: center;
}
.style-chooser .style-chooser-inner .dropdown-toggle .menu-label {
  flex: 0 0 calc(100% - 2rem);
}
.style-chooser .style-chooser-inner .dropdown-toggle .color-arrow {
  flex: 0 0 1.5rem;
  cursor: pointer;
  padding: 0 0 0 0.5rem;
  text-align: right;
  font-size: 2rem;
  line-height: 2rem;
}
@media (max-width: 768px) {
  .style-chooser .style-chooser-inner .dropdown-toggle {
    height: 3.6rem;
  }
  .style-chooser .style-chooser-inner .dropdown-toggle .color-arrow {
    font-size: 3rem;
  }
  .style-chooser .style-chooser-inner .dropdown-toggle .menu-label {
    flex: 0 0 calc(100% - 3rem);
  }
}
.style-chooser .style-chooser-inner .style-chooser-btn {
  display: block;
  width: 100%;
  padding: 0.3rem 1rem;
  background: none;
  border: none;
  text-align: left;
  font: inherit;
  color: #333;
  cursor: pointer;
  white-space: nowrap;
}
.style-chooser .style-chooser-inner .style-chooser-btn:hover {
  background-color: #f5f5f5;
  color: #262626;
}
.style-chooser .style-chooser-inner .style-chooser-btn:focus {
  outline: revert;
}
.style-chooser .style-chooser-inner hr {
  margin: 1rem;
}
.style-chooser .style-chooser-inner .use-in-events {
  display: flex;
  flex-flow: row;
  align-items: baseline;
  padding-left: 1rem;
  cursor: pointer;
}
.style-chooser .style-chooser-inner .use-in-events .use-in-events-btn {
  display: flex;
  flex-flow: row;
  align-items: baseline;
  background: none;
  border: none;
  font: inherit;
  padding: 0;
  cursor: pointer;
}
.style-chooser .style-chooser-inner .use-in-events .use-in-events-btn span {
  padding: 0;
  pointer-events: none;
}
.style-chooser .style-chooser-inner .use-in-events .use-in-events-btn span + span {
  padding-left: 1rem;
}
.style-chooser .style-chooser-inner .use-in-events .use-in-events-btn:focus {
  outline: revert;
}
.style-chooser .style-chooser-inner .use-in-events .complete {
  color: #dabc64;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Layout/ApplicationNavigation/RouteSections/Styles/Styles.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AACA;EACE,eAAA;AAEF;;AAGI;EACE,aAAA;EACA,cAAA;EACA,mBAAA;AAAN;AAEM;EACE,2BAAA;AAAR;AAGM;EACE,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AADR;AAIM;EAlBF;IAmBI,cAAA;EADN;EAEM;IACE,eAAA;EAAR;EAGM;IACE,2BAAA;EADR;AACF;AAKI;EACE,cAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AAHN;AAKM;EACE,yBAAA;EACA,cAAA;AAHR;AAMM;EACE,eAAA;AAJR;AAQI;EACE,YAAA;AANN;AASI;EACE,aAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;AAPN;AASM;EACE,aAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;AAPR;AASQ;EACE,UAAA;EACA,oBAAA;AAPV;AAUQ;EACE,kBAAA;AARV;AAWQ;EACE,eAAA;AATV;AAaM;EACE,cD/ED;ACoEP","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import 'Colors.scss';\n@import 'Variables.scss';\n\n.font-option {\n  cursor: pointer;\n}\n\n.style-chooser {\n  .style-chooser-inner {\n    .dropdown-toggle {\n      display: flex;\n      flex-flow: row;\n      align-items: center;\n\n      .menu-label {\n        flex: 0 0 calc(100% - 2rem);\n      }\n\n      .color-arrow {\n        flex: 0 0 1.5rem;\n        cursor: pointer;\n        padding: 0 0 0 0.5rem;\n        text-align: right;\n        font-size: 2rem;\n        line-height: 2rem;\n      }\n\n      @media (max-width: $tablet) {\n        height: 3.6rem;\n        .color-arrow {\n          font-size: 3rem;\n        }\n\n        .menu-label {\n          flex: 0 0 calc(100% - 3rem);\n        }\n      }\n    }\n\n    .style-chooser-btn {\n      display: block;\n      width: 100%;\n      padding: 0.3rem 1rem;\n      background: none;\n      border: none;\n      text-align: left;\n      font: inherit;\n      color: #333;\n      cursor: pointer;\n      white-space: nowrap;\n\n      &:hover {\n        background-color: #f5f5f5;\n        color: #262626;\n      }\n\n      &:focus {\n        outline: revert;\n      }\n    }\n\n    hr {\n      margin: 1rem;\n    }\n\n    .use-in-events {\n      display: flex;\n      flex-flow: row;\n      align-items: baseline;\n      padding-left: 1rem;\n      cursor: pointer;\n\n      .use-in-events-btn {\n        display: flex;\n        flex-flow: row;\n        align-items: baseline;\n        background: none;\n        border: none;\n        font: inherit;\n        padding: 0;\n        cursor: pointer;\n\n        span {\n          padding: 0;\n          pointer-events: none;\n        }\n\n        span + span {\n          padding-left: 1rem;\n        }\n\n        &:focus {\n          outline: revert;\n        }\n      }\n\n      .complete {\n        color: $gold;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
